import * as turf from "@turf/turf";

//Helper function to check if a point is inside a polygon using Turf.js
function isPointInPolygon(point, polygonCoordinates) {
  const pt = turf.point([point.lng, point.lat]);
  const poly = turf.polygon(polygonCoordinates);
  return turf.booleanPointInPolygon(pt, poly);
}

// Helper function to convert travelRegions from objects to arrays and close the polygon
function convertAndCloseTravelRegions(travelRegions) {
  return travelRegions.map((region) => {
    // Convert { lat, lng } to [lng, lat]
    const coordinates = region.map((coord) => [coord.lng, coord.lat]);

    // Ensure the polygon is closed by adding the first point to the end
    if (
      coordinates.length > 0 &&
      !turf.booleanEqual(
        turf.point(coordinates[0]),
        turf.point(coordinates[coordinates.length - 1])
      )
    ) {
      coordinates.push(coordinates[0]);
    }

    return coordinates;
  });
}

/**
 * Calculates distance using Turf.js between two geographic points.
 *
 * @param {Array} pointA - [longitude, latitude] of point A.
 * @param {Array} pointB - [longitude, latitude] of point B.
 * @returns {number} - Approximate distance in kilometers.
 */
function calculateTurfDistance(pointA, pointB, distanceUnit) {
  const point1 = turf.point(pointA);
  const point2 = turf.point(pointB);
  const distance = turf.distance(point1, point2, { units: distanceUnit });
  return distance;
}

export {
  isPointInPolygon,
  convertAndCloseTravelRegions,
  calculateTurfDistance,
};
